import { string, object } from '@gogame/schemas';

import {
  CONDITION_TYPE,
  METRIC,
  OPERATOR,
  CALCULATION_TYPE,
  VALUE,
  PERCENTILE,
} from './constants';

export const staticConditionValidationSchema = object({
  [CONDITION_TYPE]: string(),
  [METRIC]: string().required('Metric is required'),
  [OPERATOR]: string().required('Operator is required'),
  [VALUE]: string().required('Value is required'),
});

export const dynamicConditionValidationSchema = object({
  [CONDITION_TYPE]: string(),
  [METRIC]: string().required('Metric is required'),
  [OPERATOR]: string().required('Operator is required'),
  [CALCULATION_TYPE]: string().default(PERCENTILE),
  [VALUE]: string(),
});

export const formulaConditionValidationSchema = object({
  [CONDITION_TYPE]: string(),
  [METRIC]: string().required('Metric is required'),
  [OPERATOR]: string().required('Operator is required'),
  [VALUE]: string().required('Formula is required'),
});
